import {
    faBuilding,
    faTools,
    faConciergeBell,
    faGlobe,
    faChartBar,
    faSatelliteDish,
    faShieldAlt,
    faUsers,
    faSearch,
    faDatabase,
    faList,
    faFolder,
} from '@fortawesome/free-solid-svg-icons';

const groupIcons = {
    PROFILE: faBuilding,
    TRADES: faTools,
    SERVICES: faConciergeBell,
    TERRITORY: faGlobe,
    SCALE: faChartBar,
    SIGNALS: faSatelliteDish,
    COMPLIANCE: faShieldAlt,
    CONTACTS: faUsers,
    DISCOVERY: faSearch,
    SOURCES: faDatabase,
    LISTS: faList,
};

export function getGroupIcon(groupKey) {
    return groupIcons[groupKey] || faFolder;
}

export default groupIcons;
